import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/vue'

Vue.config.productionTip = false

Sentry.init({
  Vue: Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
